import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import FieldErrors from './FieldErrors'
import classnames from 'classnames'

class FormGroup extends React.Component {
  constructor(props) {
    super(props)
  }

  onBlur = (e) => {
  }

  render() {
    const onBlur = this.props.onBlur ? this.props.onBlur : this.onBlur
    const hasErrors = this.props.errors && this.props.errors.length > 0
    const setId = this.props.label.replace(/ +/g, '-').toLowerCase()

    return(
      <div className="form-group">
        <label htmlFor={setId}>{this.props.label}</label>
        {this.props.type == "textarea" ?
          <textarea
            value={this.props.value || ""}
            onBlur={onBlur}
            onChange={(e) => this.props.onChange(e.target.value)}
            className={classnames('form-control', {'is-invalid': hasErrors})}
          />
          :
          <input
            value={this.props.value || ""}
            onBlur={onBlur}
            onChange={(e) => this.props.onChange(e.target.value)}
            className={classnames('form-control', {'is-invalid': hasErrors})}
            id={setId}
          />
        }
        <FieldErrors errors={this.props.errors} />
      </div>
    )
  }
}

export default FormGroup